module.exports = __webpack_public_path__ + "static/img/top.a0afff4e.png";